<template>
    <div class="booker-avatar">
        <p class="title">Profile photo</p>
        <div v-if="imageCropped && userData.avatar.length" class="avatar">
            <img :src="previewSrc(userData.avatar[0])" alt="cropped-image" class="image" />
            <button @click="triggerUpload" class="add-image-btn">
                <img
                    :src="getImage('add-btn.svg', 'icons')"
                    alt="add-image-btn"
                    class="add-image-btn-img"
                />
                <input
                    ref="uploader"
                    type="file"
                    @change="upload"
                    accept="image/*"
                    hidden="hidden"
                />
            </button>
        </div>
        <div v-else class="avatar-placeholder">
            <img
                :src="getImage('avatar_placeholder.png')"
                alt="avatar-placeholder"
                class="avatar-placeholder-img"
            />
            <button @click="triggerUpload" class="add-image-btn">
                <img
                    :src="getImage('add-btn.svg', 'icons')"
                    alt="add-image-btn"
                    class="add-image-btn-img"
                />
                <input
                    ref="uploader"
                    type="file"
                    @change="upload"
                    accept="image/*"
                    hidden="hidden"
                />
            </button>
        </div>
    </div>
</template>
<script>
    import { useAssets } from '@/composables/utils/useAssets'

    export default {
        name: 'BookerAvatar',
        props: {
            userData: {
                type: Object,
                required: true
            },
            imageCropped: {
                type: Boolean,
                required: true
            }
        },
        setup() {
            const { getImage } = useAssets()

            return {
                getImage
            }
        },
        computed: {
            previewSrc() {
                return (media) => {
                    if (media instanceof File) {
                        return URL.createObjectURL(media)
                    } else {
                        return media?.src ?? ''
                    }
                }
            }
        },
        methods: {
            triggerUpload() {
                if (this.userData.avatar.length) {
                    this.$emit('crop-image')
                } else {
                    this.$refs.uploader.click()
                }
            },
            upload(e) {
                if (!e.target.files.length) return
                Array.from(e.target.files).forEach((file) => {
                    this.userData.avatar.push(file)
                    this.$emit('crop-image')
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .booker-avatar {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 24px;

        .title {
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }

        .avatar {
            position: relative;
            align-self: center;

            .image {
                width: 100%;
                width: 344px;
                height: 344px;
                border-radius: 50%;
                object-fit: cover;
            }
            .add-image-btn {
                position: absolute;
                width: 16px;
                padding: 0px;
                bottom: 40px;
                right: 42px;
                background: none;

                .add-image-btn-img {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
        }
        .avatar-placeholder {
            position: relative;
            align-self: center;

            .avatar-placeholder-img {
                width: 344px;
                height: 344px;
                border-radius: 50%;
                object-fit: cover;
            }
            .add-image-btn {
                position: absolute;
                width: 16px;
                padding: 0px;
                bottom: 40px;
                right: 42px;
                background: none;

                .add-image-btn-img {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
        }
    }
</style>
